import React, { useState, useEffect } from 'react';
import { getAllBookings, updateBookingStatus } from '../../services/api';

const AdminDashboard = () => {
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchBookings();
    }, []);

    const fetchBookings = async () => {
        try {
            setLoading(true);
            const response = await getAllBookings();
            setBookings(response.data);
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch bookings.');
            setLoading(false);
            console.error(err);
        }
    };

    const handleStatusUpdate = async (bookingId, newStatus) => {
        try {
            await updateBookingStatus(bookingId, newStatus);
            fetchBookings(); // Refresh the list
        } catch (err) {
            setError('Failed to update booking status.');
            console.error(err);
        }
    };

    if (loading) return <div className="text-center mt-8">Loading bookings...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="container mx-auto p-4">
            <h2 className="text-3xl font-bold mb-6 text-center">Admin Dashboard - All Bookings</h2>
            <div className="bg-white p-6 rounded-lg shadow-md">
                {bookings.length === 0 ? (
                    <p className="text-center text-gray-600">No bookings found.</p>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="min-w-full bg-white">
                            <thead>
                                <tr>
                                    <th className="py-2 px-4 border-b text-left">ID</th>
                                    <th className="py-2 px-4 border-b text-left">User ID</th>
                                    <th className="py-2 px-4 border-b text-left">Start Time</th>
                                    <th className="py-2 px-4 border-b text-left">End Time</th>
                                    <th className="py-2 px-4 border-b text-left">Amount</th>
                                    <th className="py-2 px-4 border-b text-left">Status</th>
                                    <th className="py-2 px-4 border-b text-left">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bookings.map((booking) => (
                                    <tr key={booking.id}>
                                        <td className="py-2 px-4 border-b">{booking.id}</td>
                                        <td className="py-2 px-4 border-b">{booking.user_id}</td>
                                        <td className="py-2 px-4 border-b">{new Date(booking.start_time).toLocaleString()}</td>
                                        <td className="py-2 px-4 border-b">{new Date(booking.end_time).toLocaleString()}</td>
                                        <td className="py-2 px-4 border-b">${(booking.amount / 100).toFixed(2)}</td>
                                        <td className="py-2 px-4 border-b">{booking.status}</td>
                                        <td className="py-2 px-4 border-b">
                                            {booking.status === 'pending' && (
                                                <>
                                                    <button
                                                        className="bg-green-500 hover:bg-green-700 text-white font-bold py-1 px-2 rounded text-sm mr-2"
                                                        onClick={() => handleStatusUpdate(booking.id, 'approved')}
                                                    >
                                                        Approve
                                                    </button>
                                                    <button
                                                        className="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-2 rounded text-sm"
                                                        onClick={() => handleStatusUpdate(booking.id, 'rejected')}
                                                    >
                                                        Reject
                                                    </button>
                                                </>
                                            )}
                                            {booking.status === 'approved' && (
                                                <span className="text-green-600">Approved</span>
                                            )}
                                            {booking.status === 'rejected' && (
                                                <span className="text-red-600">Rejected</span>
                                            )}
                                            {booking.status === 'paid' && (
                                                <span className="text-blue-600">Paid</span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminDashboard;